import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { NovaCoin3D } from './NovaCoin3D.js';

interface CoinParticle {
  id: number;
  x: number;
  y: number;
  targetY: number;
  targetX: number;
  scale: number;
  rotation: number;
  delay: number;
}

interface FloatingCoinsEffectProps {
  triggerKey: number; // incrementing counter that fires the burst
}

export const FloatingCoinsEffect: React.FC<FloatingCoinsEffectProps> = ({ triggerKey }) => {
  const [particles, setParticles] = useState<CoinParticle[]>([]);

  useEffect(() => {
    if (triggerKey <= 0) return;

    const count = 14;
    const newParticles: CoinParticle[] = [];

    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5);
      const distance = 80 + Math.random() * 90;

      newParticles.push({
        id: Date.now() + i,
        x: (Math.random() - 0.5) * 40,
        y: 0,
        targetX: Math.cos(angle) * distance,
        targetY: -120 - Math.random() * 140, // ascend upward
        scale: 0.6 + Math.random() * 0.5,
        rotation: (Math.random() - 0.5) * 360,
        delay: Math.random() * 0.15,
      });
    }

    setParticles(newParticles);

    const timer = setTimeout(() => {
      setParticles([]);
    }, 1800);

    return () => clearTimeout(timer);
  }, [triggerKey]);

  if (particles.length === 0) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50 flex items-center justify-center overflow-hidden">
      <AnimatePresence>
        {particles.map((p) => (
          <motion.div
            key={p.id}
            initial={{
              opacity: 1,
              x: p.x,
              y: p.y,
              scale: 0.4,
              rotate: 0,
            }}
            animate={{
              opacity: [1, 1, 0],
              x: p.targetX,
              y: p.targetY,
              scale: p.scale,
              rotate: p.rotation,
            }}
            transition={{
              duration: 1.4,
              delay: p.delay,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="absolute"
          >
            <NovaCoin3D size="sm" />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
